import { RouteType } from "../../../types/RouteType";

const qcInspectorDashboardRoute: RouteType = {
  name: "QC Inspector Dashboard",
  path: "/qc/inspector",
  layout: "/app",
  viewportCard: {
    header: {
      component: () => import("./QCInspectorDashboard.Header"),
      title: "QC Inspector Dashboard",
      color: "primary",
      enableRefreshButton: true,
    },
    body: {
      component: () => import("./QCInspectorDashboard.Body"),
      grayBackground: true,
    },
  },
  group: "Quality Control",
  requiresAuth: true,
  requiresPermission: false, // TODO: Add 'qc:inspector' permission check

  beforeEnter: async ({ rootStore }) => {
    try {
      const store = rootStore.qcInspectorDashboardStore;
      if (store && typeof store === "object" && "loadDashboardData" in store) {
        await (store as any).loadDashboardData();
      }
      return true;
    } catch (error) {
      console.error("Failed to load QC Inspector Dashboard:", error);
      return false;
    }
  },

  onExit: ({ rootStore }) => {
    const store = rootStore.qcInspectorDashboardStore;
    if (store && typeof store === "object" && "reset" in store) {
      (store as any).reset();
    }
  },

  dialogs: [],
};

export default qcInspectorDashboardRoute;
